<template>
    <footer class="footer">
        <div class="content has-text-centered">
            <p>
                Copyright © Creek Coding 2022
            </p>

            <a href="https://github.com/Creek-Coding/Creek-Coding-Website" target="_blank" class="button is-dark">
                <span class="icon">
                    <i class="fa fa-github"> </i>
                </span>
                <span>GitHub</span>
            </a>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>
